import * as React from 'react';

const FilePicker = (props:any) => (
    <svg
        width={64}
        height={64}
        viewBox="0 0 64 64"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <g fill="none">
            <g transform="translate(-561 -217)translate(561 202)translate(10 25)">
                <path d="M2 2L2 42 42 42 42 2 2 2Z" strokeWidth="4" stroke="#D2D5D8" />
                <rect x="4" width="4" height="4" fill="#FFF" />
                <rect x="12" width="4" height="4" fill="#FFF" />
                <rect x="20" width="4" height="4" fill="#FFF" />
                <rect x="28" width="4" height="4" fill="#FFF" />
                <rect x="36" width="4" height="4" fill="#FFF" />
                <rect x="40" y="4" width="4" height="4" fill="#FFF" />
                <rect x="40" y="12" width="4" height="4" fill="#FFF" />
                <rect x="40" y="20" width="4" height="4" fill="#FFF" />
                <rect x="40" y="28" width="4" height="4" fill="#FFF" />
                <rect x="40" y="36" width="4" height="4" fill="#FFF" />
                <rect x="36" y="40" width="4" height="4" fill="#FFF" />
                <rect x="28" y="40" width="4" height="4" fill="#FFF" />
                <rect x="20" y="40" width="4" height="4" fill="#FFF" />
                <rect x="12" y="40" width="4" height="4" fill="#FFF" />
                <rect x="4" y="40" width="4" height="4" fill="#FFF" />
                <rect y="36" width="4" height="4" fill="#FFF" />
                <rect y="28" width="4" height="4" fill="#FFF" />
                <rect y="20" width="4" height="4" fill="#FFF" />
                <rect y="12" width="4" height="4" fill="#FFF" />
                <rect y="4" width="4" height="4" fill="#FFF" />
                <g transform="translate(12 10)">
                    <polygon points="0 0 14.3 0 20 6.2 20 24 0 24" fill="#7B838C" />
                    <path d="M4 10L16 10" strokeWidth="2" stroke="#E8E9EB" />
                    <path d="M4 15L16 15" strokeWidth="2" stroke="#E8E9EB" />
                </g>
            </g>
        </g>
    </svg>
);

export default FilePicker;
